// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"ab34b5c2","430":"bc9bdd3e","788":"848a8c0c","860":"76243d7b"}[chunkId] + ".chunk.js";
};